export default __webpack_public_path__ + "static/media/readMessage.c01a0369.svg";